import { closeBrowser } from './closeBrowser.js';
import { closeMetashop } from './closeMetashop.js';
import { openExternalUrl } from './openExternalUrl.js';
import { updateBrowserControlState } from './updateBrowserControlState.js';
import { updateBrowserOverScrollableState } from './updateBrowserOverScrollableState.js';
import { completeAccount } from './completeAccount.js';
import { coachCompleteAccount } from './coachCompleteAccount.js';
import { goToWebProject } from './goToWebProject.js';
import { earlyWebContentLoading } from './earlyWebContentLoading.js';
import { openBattlePass } from './openBattlePass.js';
import { openRvR } from './openRvR.js';
import { navigateTo } from './navigateTo.js';
import { getUserGraphicsQualityPreset } from './getUserGraphicsQualityPreset.js';

var browser = {
    closeBrowser,
    closeMetashop,
    openExternalUrl,
    updateBrowserControlState,
    updateBrowserOverScrollableState,
    goToWebProject,
    completeAccount,
    coachCompleteAccount,
    earlyWebContentLoading,
    openBattlePass,
    openRvR,
    navigateTo,
    getUserGraphicsQualityPreset,
};

export { browser as default };
//# sourceMappingURL=index.js.map
